import React from 'react';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { mockupUrl, offerAnchor, productName } from '../data/content';
import { Button } from './ui/Button';
import { OfferLink } from './ui/OfferLink';
export function FinalClose() {
  return <section className="bg-brand px-4 py-12 md:py-16" data-id="element-64" data-mp="n4asycocg3b3">
      <div className="mx-auto max-w-3xl text-center" data-id="element-65" data-mp="i5raim8yl9nh">
        <p className="text-[11px] font-black uppercase tracking-[.25em] text-accent-light md:text-xs" data-id="element-66" data-mp="i7c2c43w2ehn">One last question</p>
        <h2 className="mx-auto mt-3 max-w-2xl text-xl font-black uppercase leading-snug text-white md:text-3xl" data-id="element-67" data-mp="1atww1b7u72od">
          How much easier would your work be with your lumbar rehabilitation resources already organized?
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-sm font-black uppercase tracking-wider text-accent-light md:text-base" data-id="element-68" data-mp="112scdy77utn7">
          Exercises. Mobility. Strength. Functional rehabilitation. Complete sessions. Patient programs. Clinical tools.
        </p>
        <p className="mx-auto mt-3 max-w-xl text-sm font-bold text-white" data-id="element-69" data-mp="npc6fomlrcfd">
          One professional collection. Everything organized in one place.
        </p>

        <OfferLink className="mx-auto mt-8 max-w-[260px]" href={offerAnchor} label={`${productName} offer`} data-id="element-70" data-mp="snvrznxaam77">
          <img src={mockupUrl} alt={`${productName} 3D product mockup`} className="w-full object-contain drop-shadow-2xl transition-transform duration-300 ease-out group-hover:scale-[1.015]" data-id="element-71" data-mp="dz97l7ssv494" />
        </OfferLink>

        <p className="mt-6 text-lg font-black uppercase text-white md:text-xl" data-id="element-72" data-mp="90od7p08besl">{productName}</p>
        <div className="mt-4" data-id="element-73" data-mp="3r6uh03trexjh">
          <Button href={offerAnchor} size="lg" subtext="5 Complete Volumes + 5 Practical Bonuses" data-id="element-74" data-mp="3r7m2gltn7ew1">
            Yes! I want the complete bundle
          </Button>
        </div>
        <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-[11px] font-bold uppercase tracking-wide text-white/85" data-id="element-75" data-mp="1pfpqxc7h6519">
          <li className="flex items-center gap-1.5" data-id="element-76" data-mp="1uboif8o3o35w">
            <ZapIcon className="h-4 w-4 text-accent-light" aria-hidden="true" data-id="element-77" data-mp="1swvi7xyt40w2" /> Instant Digital Access
          </li>
          <li className="flex items-center gap-1.5" data-id="element-78" data-mp="1nwprck0d2if1">
            <ShieldCheckIcon className="h-4 w-4 text-accent-light" aria-hidden="true" data-id="element-79" data-mp="1iy61w9mk6ohx" /> 7-Day Guarantee
          </li>
        </ul>
      </div>
    </section>;
}